import api from './apiService';
import apiRoutes from './apiRoutes';


// Deposit details — map the enriched V2 DTO back to the names DisplayDeposit reads.
export const getDepositDetailsAsync = async (depositId) => {
  try {
    const response = await api.get(apiRoutes.getDepositDetails(depositId));
    const d = response.result || {};
    return {
      result: {
        ...d,
        auditorState: d.state,
        auditorRejectReason: d.rejectReason,
        auditorNoteToClient: d.auditorNote,
        reviewerNoteToClient: d.reviewerNote,
        validationFields: (d.validationFields || []).map((f) => ({
          ...f,
          validationFieldId: f.depositValidationFieldId,
        })),
      },
    };
  } catch (error) {
    throw error;
  }
};


// Get All Achievements — V2 returns a PagedResult; unwrap to the items array.
export const getAllDeposits = async (year,fromDate = null, toDate = null) => {
  try {
    const params = {};
    if (year) params.year = year;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    const response = await api.get(apiRoutes.getAllAchievements, { params });
    return response.result.items || [];
  } catch (error) {
    throw error;
  }
};
// Deposit form — reconstruct the legacy { depositForm, validationFields } shape from the
// enriched V2 flat DTO (Gap 6 added sequences + descriptions).
export const getDepositForm = async (itemId) => {
  try {
    const response = await api.get(apiRoutes.getDepositForm(itemId));
    const d = response.result || {};
    return {
      depositForm: {
        itemId: d.itemId,
        itemName: d.itemName,
        itemScore: d.score,
        itemSequence: d.itemSequence,
        itemDescription: d.itemDescription,
        mainStandardName: d.mainStandardName,
        mainStandardSequence: d.mainStandardSequence,
        subStandardName: d.subStandardName,
        subStandardSequence: d.subStandardSequence,
        validationGroupVersionId: d.validationGroupVersionId,
      },
      validationFields: (d.fields || []).map((f) => ({
        validationFieldVersionId: f.validationFieldVersionId,
        fieldName: f.fieldName,
        fieldType: f.fieldType,
        fieldDescription: f.fieldDescription,
        required: f.required,
        isAchievementDate: f.isAchievementDate,
      })),
    };
  } catch (error) {
    throw error;
  }
};

// Get Employee Account Statement — token-scoped in V2 (no idNumber).
export const getAccountStatement = async () => {
  try {
    const response = await api.get(apiRoutes.getAccountStatement);
    return response.result;
  } catch (error) {
    throw error;
  }
};

// Get Employee Archive (legacy pre-system) deposits — token-scoped in V2.
export const getArchiveAccountStatement = async () => {
  try {
    const response = await api.get(apiRoutes.getArchiveDeposits);
    return response.result;
  } catch (error) {
    throw error;
  }
};

// Post New Achievement — V2 is a single multipart POST (itemId + validationFieldValues + files).
// Caller passes a ready FormData.
export const postNewDeposit = async (formData) => {
  try {
    const response = await api.post(apiRoutes.postNewDeposit, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.result;
  } catch (error) {
    throw error;
  }
};
